import { HttpParams } from '@angular/common/http';
import { UniqaSyncJobGetQueryParamsInterface } from './definitions/uniqa-sync-job-get-query-params.interface';

export function createUniqaSyncJobQueryParams(paramsObj: UniqaSyncJobGetQueryParamsInterface): HttpParams {
  let params: HttpParams = new HttpParams();

  params = params.set('page', paramsObj.Page.toString());
  params = params.set('pageSize', paramsObj.PageSize.toString());

  if (paramsObj.Search !== null && paramsObj.Search !== undefined && paramsObj.Search !== '') {
    params = params.set('search', paramsObj.Search);
  }

  if (paramsObj.Status !== null && paramsObj.Status !== undefined && paramsObj.Status.length > 0) {
    for (const status of paramsObj.Status) {
      params = params.append('status', status);
    }
  }

  if (paramsObj.OrderBy !== null && paramsObj.OrderBy !== undefined && paramsObj.OrderBy !== '') {
    params = params.set('orderBy', paramsObj.OrderBy);
  }

  if (paramsObj.OrderByDescending !== null && paramsObj.OrderByDescending !== undefined) {
    params = params.set('orderByDesc', paramsObj.OrderByDescending.toString());
  }

  return params;
}
